import { render, staticRenderFns } from "./PayrollPayments.vue?vue&type=template&id=b7b6a0d2&scoped=true"
import script from "./PayrollPayments.vue?vue&type=script&lang=js"
export * from "./PayrollPayments.vue?vue&type=script&lang=js"
import style0 from "./PayrollPayments.vue?vue&type=style&index=0&id=b7b6a0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b6a0d2",
  null
  
)

export default component.exports